import { Contacts } from '@/components';

const ContactsRoute = () => <Contacts />;

export default ContactsRoute;
